export enum ExamPropertiesTabNames {
    Users = 'USERS',
    Features = 'FEATURES',
    Time = 'TIME',
    Document = 'DOCUMENT',
    Cloud = 'CLOUD',
    UnlockCode = 'UNLOCKCODE',
    // General = 'GENERAL'
  }